import { DocPreviewer } from "@onefront/documents-smart-components";
import { ArrowLeft } from "@vapor/react-icons";
import { IconButton } from "@vapor/react-material";
import React from "react";
import { useParams } from "react-router-dom";

export const PreviewTheNavigatedDoc: React.FC = () => {
  const { id, workspaceId } = useParams<{
    workspaceId: string | undefined;
    id: string | undefined;
  }>();
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    marginLeft: "15%",
  };

  const headerDivStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingLeft: "5%",
    paddingTop: "10px",
  };

  const handleClose = () => {
    window.history.go(-1);
  };

  return (
    <div>
      <div style={headerDivStyle}>
        <IconButton color="primary" size="large" onClick={handleClose}>
          <ArrowLeft />
        </IconButton>
      </div>
      <div style={containerStyle}>
        <DocPreviewer
          isInvoice={false}
          height={"100vh"}
          id={id}
          workspaceId={workspaceId}
        />
      </div>
    </div>
  );
};
